import React, { useEffect, useRef, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

/**
 * CKEditor sarmalayıcısı.
 *
 * Editöre her tuşta güncel metni `data` olarak geri vermek (kontrollü kullanım)
 * boş editörde imleci başa atıyordu: "abc def" yazan kullanıcı "bc defa"
 * görüyordu (blog ekleme ve çeviri pencerelerinde). Burada editör yalnızca
 * açılışta metni alıyor; sonrasında yazılanlar editörde kalıyor. Metin dışarıdan
 * değişirse (ör. kayıt sonradan yüklendiğinde veya form sıfırlandığında)
 * editöre yeniden yazılıyor.
 */
export default function RichEditor({ value, onChange, config }) {
  const editorRef = useRef(null);
  const lastEmitted = useRef(value || "");
  const [initial] = useState(value || "");

  useEffect(() => {
    const next = value || "";
    if (next === lastEmitted.current) return;
    lastEmitted.current = next;
    // Editör henüz hazır değilse onReady bu değeri yazar.
    const editor = editorRef.current;
    if (editor && editor.getData() !== next) editor.setData(next);
  }, [value]);

  return (
    <CKEditor
      editor={ClassicEditor}
      data={initial}
      config={config}
      onReady={(editor) => {
        editorRef.current = editor;
        const current = lastEmitted.current;
        if (editor.getData() !== current) editor.setData(current);
      }}
      onChange={(event, editor) => {
        const data = editor.getData();
        lastEmitted.current = data;
        onChange(data);
      }}
    />
  );
}
